// Action Types
export const FETCH_BATTLE_CARD_REQUEST = "FETCH_BATTLE_CARD_REQUEST";
export const FETCH_BATTLE_CARD_SUCCESS = "FETCH_BATTLE_CARD_SUCCESS";
export const FETCH_BATTLE_CARD_FAILURE = "FETCH_BATTLE_CARD_FAILURE";


// Action Creators
export const fetchBattleCardRequest = ({opportunityId}) => {
  return (dispatch) => {
    dispatch({
      type: FETCH_BATTLE_CARD_REQUEST,
      payload: {opportunityId},
    });
  };
};
export const fetchBattleCardSuccess = (data) => ({
  type: FETCH_BATTLE_CARD_SUCCESS,
  payload: data,
});
export const fetchBattleCardFailure = (error) => ({
  type: FETCH_BATTLE_CARD_FAILURE,
  payload: error,
});
